
import React, { useState, useEffect } from 'react';
import '../css/dataTablePopUp.css';

const JoinPopupComponent = ({ onClose, onRemoveTable, nodeName, selectedNodeId, onValueSubmit,
  nodes, setNodes, edges,setEdges, droppedNodes, setDroppedNodes, data, selectedPreviousTable,
  firstJoinTypeValues, datatableOneFirstValue, datatableTwoFirstValue,
  additionalLogicalOperatorsValue, additionalColumnOneValues, additionalColumnTwoValues,
  showAdditionalColumnslength, firstCompareToValues, additionalCompareTypeValues,
  selectedCatalogUntilJoinNode,
  selectedDatabaseUntilJoinNode,
  selectedTablesUntilJoinNode,
  selectedColumnsUntilJoinNode,
  datatableOne, datatableTwo, windowFunctionWithCondition, aliasColumn,
  connectionType }) => {

  console.log(JSON.stringify(aliasColumn) + "aliasColumn");
  console.log(JSON.stringify(windowFunctionWithCondition) + "windowFunctionWithCondition");
  console.log(JSON.stringify(selectedCatalogUntilJoinNode) + "selectedCatalogUntilJoinNode**");

  console.log(JSON.stringify(selectedDatabaseUntilJoinNode) + "selectedDatabaseUntilJoinNode**");

  console.log(JSON.stringify(selectedTablesUntilJoinNode) + "selectedTablesUntilJoinNode**");

  console.log(JSON.stringify(selectedColumnsUntilJoinNode) + "selectedColumnUntilJoinNode**");

  console.log("datatableOneFirstValue: " + JSON.stringify(datatableOneFirstValue) + "--"
    + "datatableTwoFirstValue: " + JSON.stringify(datatableTwoFirstValue) + "--"
    + "additionalColumnOneValues: " + JSON.stringify(additionalColumnOneValues) + "--"
    + "additionalColumnTwoValues: " + JSON.stringify(additionalColumnTwoValues) + "--"
    + "showAdditionalColumnslength: " + JSON.stringify(showAdditionalColumnslength) + "--"
    + "firstCompareToValues: " + JSON.stringify(firstCompareToValues) + "--"
    + "additionalCompareTypeValues: " + JSON.stringify(additionalCompareTypeValues) + "--"
    + "selectedTablesUntilJoinNode: " + JSON.stringify(selectedTablesUntilJoinNode) + "--"
    + "datatableOne: " + JSON.stringify(datatableOne) + "--"
    + "datatableTwo: " + JSON.stringify(datatableTwo) + "--");
  console.log(JSON.stringify(datatableOne) + "datatableOneINITIAL");
  console.log(JSON.stringify(datatableTwo) + "datatableTwoINITIAL");
  console.log(JSON.stringify(selectedTablesUntilJoinNode) + "selectedTablesUntilJoinNode++++++=");
  console.log(JSON.stringify(additionalColumnOneValues) + "INITIALadditionalColumnOneValues");
  console.log(showAdditionalColumnslength + "showAdditionalColumnslength");
  const dropdownJoinTypeOptions = [
    { value: 'INNER JOIN', label: 'Only matches from both' },
    { value: 'LEFT JOIN', label: 'All of Table 1, with matches from Table 2' },
    { value: 'RIGHT JOIN', label: 'All of Table 2, with matches from Table 1' },
    { value: 'FULL OUTER JOIN', label: 'All of both tables, matched where possible' },
    { value: 'Cross', label: 'Every possible combination' }

  ];

  const dropdownLogicalOperator = [
    { value: 'and', label: 'AND' },
    { value: 'or', label: 'OR' }
  ];

  const dropdownCompareToOptions = [
    { value: 'EqualTo', label: 'is equal to', symbol: '=' },
    { value: 'DoesNotEqual', label: 'is not equal to', symbol: '!=' },
  ];

  const [isChecked, setIsChecked] = useState(false);
  const [name, setName] = useState(nodeName);
  //alert(JSON.stringify(selectedTablesUntilJoinNode)+"selectedTablesUntilJoinNode");


  let selectedLastTableJoinNode;
  let selectedLastColumnJoinNode;
  let selectedLastTableLastName;
  let selectedLastDatabaseLastName;
  let selectedLastTableLastColumnName;
  if (selectedTablesUntilJoinNode.length > 0) {
    selectedLastTableJoinNode = selectedTablesUntilJoinNode[selectedTablesUntilJoinNode.length - 1];
    selectedLastColumnJoinNode = selectedColumnsUntilJoinNode[selectedColumnsUntilJoinNode.length - 1];
    selectedLastDatabaseLastName = selectedDatabaseUntilJoinNode[selectedDatabaseUntilJoinNode.length - 1];
    selectedLastTableLastName = selectedLastTableJoinNode;
    // alert(JSON.stringify(selectedLastTableLastName)+"selectedLastTableLastName");
    selectedLastTableLastColumnName = selectedLastColumnJoinNode;
    // alert(JSON.stringify(selectedLastColumnJoinNode[0]) + "selectedLastColumnJoinNode");
    console.log(JSON.stringify(selectedLastTableLastName) + "---" + JSON.stringify(selectedLastTableLastColumnName[0]) + "selectedLastTableLastColumnName");
    // alert(JSON.stringify(selectedLastDatabaseLastName) + "selectedLastDatabaseLastName");
  } else {
    selectedLastTableJoinNode = '';
    selectedLastTableLastName = '';
    selectedLastTableLastColumnName = '';
    selectedLastDatabaseLastName = '';
  }

  const [joinType, setJoinType] = useState(
    firstJoinTypeValues !== undefined ? firstJoinTypeValues : dropdownJoinTypeOptions[0].value
  );

  const [datatableListOne, setDatatableListOne] = useState(
    selectedTablesUntilJoinNode.length > 0
      ? selectedTablesUntilJoinNode[0] : ''
  );

  const [datatableListTwo, setDatatableListTwo] = useState(
    selectedTablesUntilJoinNode.length > 0
      ? selectedLastTableJoinNode : ''
  );

  const [datatableColumnOne, setDatatableColumnOne] = useState(
    //datatableOneFirstValue !== undefined ? datatableOneFirstValue :
      selectedColumnsUntilJoinNode.length > 0 ? selectedColumnsUntilJoinNode[0][0] : ''
  );
  const [datatableColumnTwo, setDatatableColumnTwo] = useState(
    //datatableTwoFirstValue !== undefined ? datatableTwoFirstValue :
      selectedColumnsUntilJoinNode.length > 0 ? selectedLastTableLastColumnName[0] : ''
  );
  console.log(JSON.stringify(datatableColumnTwo) + "datatableColumnTwo");
  console.log(JSON.stringify(datatableOne) + "datatableOne");
  console.log(JSON.stringify(datatableTwo) + "datatableTwo");
  const [showAdditionalColumns, setShowAdditionalColumns] = useState([]);

  const [additionalColumnOne, setAdditionalColumnOne] = useState(
    //  additionalColumnOneValues && additionalColumnOneValues?.length > 0 ? additionalColumnOneValues : [selectedTablesUntilJoinNode[0].columns[0]]
    additionalColumnOneValues && additionalColumnOneValues?.length > 0 ? additionalColumnOneValues : []
  );

  const [additionalColumnTwo, setAdditionalColumnTwo] = useState(
    // additionalColumnTwoValues && additionalColumnTwoValues?.length > 0 ? additionalColumnTwoValues : [selectedTablesUntilJoinNode[1].columns[0]]
    additionalColumnTwoValues && additionalColumnTwoValues?.length > 0 ? additionalColumnTwoValues : []
  );

  const [additionalLogicalOperators, setAdditionalLogicalOperators] = useState(
    additionalLogicalOperatorsValue && additionalLogicalOperatorsValue.length > 0 ? additionalLogicalOperatorsValue : []

  );
  const [compareType, setCompareType] = useState(
    firstCompareToValues !== undefined ? firstCompareToValues : dropdownCompareToOptions[0].symbol
  );

  const [additionalCompareType, setAdditionalCompareType] = useState(
    additionalCompareTypeValues && additionalCompareTypeValues.length > 0 ? additionalCompareTypeValues : dropdownCompareToOptions[0].symbol
  );
  console.log(additionalColumnOne + "additionalColumnOne*******");
  console.log(additionalColumnTwo + "additionalColumnTwo*************");

  useEffect(() => {
    setName(nodeName);
    setJoinType(joinType);
    setCompareType(compareType);
    setDatatableListOne(datatableListOne);
    setDatatableListTwo(datatableListTwo);
    setDatatableColumnOne(datatableColumnOne);
    setDatatableColumnTwo(datatableColumnTwo);
    console.log("datatableInJoin::11", JSON.stringify(datatableTwo), JSON.stringify(datatableOne), datatableListOne, datatableListTwo, selectedLastTableLastName);
    console.log("datatableInJoin::22", datatableColumnOne, datatableColumnTwo);
    if (datatableTwo !== selectedLastTableLastName) {
      console.log("Yes, it's different");
      // Clear all additional values
      setAdditionalCompareType('');
      setAdditionalColumnOne([]);
      setAdditionalColumnTwo([]);
      setShowAdditionalColumns([]);
      setAdditionalLogicalOperators('');
    } else {
      //setDatatableColumnTwo()
      setAdditionalCompareType(additionalCompareTypeValues);
      setAdditionalColumnOne(additionalColumnOneValues);
      setAdditionalColumnTwo(additionalColumnTwoValues);
      setShowAdditionalColumns(showAdditionalColumnslength > 0 ? [{}] : []);
      setAdditionalLogicalOperators(additionalLogicalOperatorsValue);
    }

    console.log(additionalColumnOne + "additionalColumnOne*******INSIDEUSEEFFECT");
    console.log(additionalColumnTwo + "additionalColumnTwo*************INSIDEE");
    console.log(JSON.stringify(additionalCompareType) + "additionalCompareType");

  }, [nodeName, joinType, compareType, datatableListOne, datatableListTwo,
    datatableColumnOne, datatableColumnTwo,
    additionalCompareTypeValues, additionalColumnOneValues, additionalColumnTwoValues,
    showAdditionalColumnslength, additionalLogicalOperatorsValue
  ]
  );

  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleLinkClick = () => {
    // Perform any actions when the link is clicked
    // ...
  };
  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);

  };

  // Function to update the dynamic value
  const handleDatatableOneChange = (event) => {
    setDatatableColumnOne(event.target.value);
  };



  // Function to update the dynamic value
  const handleDatatableTwoChange = (event) => {
    setDatatableColumnTwo(event.target.value);
  };


  const handleSelectedDatatableOneChange = (event) => {
    let correspondingColumns;
    const selectedOneTable = event.target.value;
    setDatatableListOne(selectedOneTable);

    // Find the selected table object based on the selectedTable value
    const selectedTableObject = selectedTablesUntilJoinNode.find(table => table === selectedOneTable);

    // Update the datatableColumnOne state with the column values of the selected table
    if (selectedTableObject) {
      correspondingColumns = selectedColumnsUntilJoinNode[selectedTablesUntilJoinNode.indexOf(selectedOneTable)];
      console.log(correspondingColumns);
      setDatatableColumnOne(correspondingColumns);
    }

    //alert(JSON.stringify(datatableColumnOne) + "datatableColumnOne ONCHANGE");
  };


  const handleSelectedDatatableTwoChange = (event) => {
    const selectedSecondValue = event.target.value;
    setDatatableListTwo(selectedSecondValue);

    // Update datatableColumnTwo based on the selected value
    const selectedTableObjectTwo = selectedTablesUntilJoinNode.find(table => table === selectedSecondValue);
    if (selectedTableObjectTwo) {
      setDatatableColumnTwo(selectedColumnsUntilJoinNode.length - 1);
    } else {
      setDatatableColumnTwo('');
    }

    console.log(JSON.stringify(datatableTwo) + "datatableTwoONCHANGE");
  };



  const handleSubmit = (event) => {

    event.preventDefault();
    console.log("joinEvent:::1",event)
    console.log("datatableOneFirstValue::1",JSON.stringify(datatableOneFirstValue));
    console.log("datatableTwoFirstValue::2",JSON.stringify(datatableTwoFirstValue));
    console.log("windowFunctionWithCondition::33", windowFunctionWithCondition)

    let dataTableColumnOneFunction = '';
    let dataTableColumnTwoFunction = '';

    if (windowFunctionWithCondition && windowFunctionWithCondition[0] !== '' &&
      windowFunctionWithCondition.length > 0) {
      const firstArray = windowFunctionWithCondition[0];

      // Check if the column is present in windowFunctionWithCondition
      const match = firstArray.find((item) => item.endsWith(` AS ${datatableColumnOne}`));

      if (match) {
        // If it's in windowFunctionWithCondition, return the first index of that match
        dataTableColumnOneFunction = match.split(" AS ")[0];
      } else {
        // If it's not in aliasColumns, append catalog, database, and table names
        dataTableColumnOneFunction = `${datatableColumnOne}`;
      }
    }
    else {
      // If it's not in aliasColumns, append catalog, database, and table names
      dataTableColumnOneFunction = `${datatableColumnOne}`;
    }

    if (windowFunctionWithCondition &&
      windowFunctionWithCondition[windowFunctionWithCondition.length - 1] !== '' &&
      windowFunctionWithCondition.length > 0) {
      const lastArray = windowFunctionWithCondition[windowFunctionWithCondition.length - 1];

      if (lastArray && lastArray !== '' && lastArray.length > 0) {
        // Check if the column is present in windowFunctionWithCondition
        const match = lastArray.find((item) => item.endsWith(` AS ${datatableColumnTwo}`));

        if (match) {
          // If it's in windowFunctionWithCondition, return the first index of that match
          dataTableColumnTwoFunction = match.split(" AS ")[0];
        } else {
          // If it's not in aliasColumns, append catalog, database, and table names
          dataTableColumnTwoFunction = `${datatableColumnTwo}`;
        }
      } else {
        // If it's not in aliasColumns, append catalog, database, and table names
        dataTableColumnTwoFunction = `${datatableColumnTwo}`;
      }

    }
    else {
      // If it's not in aliasColumns, append catalog, database, and table names
      console.log("datatableColumnTwo::1", datatableColumnTwo, selectedLastTableLastColumnName)
      dataTableColumnTwoFunction = `${datatableColumnTwo}`;
    }





    // Add the first column of selectFiltercolumns to selectGroupColumns
    const combinedJoinOneColumns = [dataTableColumnOneFunction, ...additionalColumnOne];
    // alert(JSON.stringify(combinedJoinOneColumns) + "combinedJoinOneColumns");

    const combinedJoinTwoColumns = [dataTableColumnTwoFunction, ...additionalColumnTwo];
    console.log(JSON.stringify(combinedJoinOneColumns) + "combinedJoinOneColumns");
    console.log(JSON.stringify(combinedJoinOneColumns) + "combinedJoinOneColumns");
    console.log(JSON.stringify(combinedJoinTwoColumns) + "combinedJoinTwoColumns");
    console.log(JSON.stringify(additionalCompareType) + "additionalCompareType");
    const combinedJoinColumnComparisonOperator = [compareType, ...additionalCompareType];
    console.log(JSON.stringify(combinedJoinColumnComparisonOperator) + "combinedJoinColumnComparisonOperator");
    console.log(JSON.stringify(combinedJoinColumnComparisonOperator) + "combinedJoinColumnComparisonOperator");
    const logicalOperators = ['', ...additionalLogicalOperators];
    console.log(JSON.stringify(logicalOperators) + "logicalOperators");

    console.log(JSON.stringify(aliasColumn) + "aliasColumn");


    const buildJoin = {
      joinType: joinType,
      columnDetails: []
    };
    if (connectionType === 'SQLite') {
      // Set the joinTable1 and joinTable2 properties with only datatableListOne and datatableListTwo
      buildJoin.joinTable1 = datatableListOne;
      buildJoin.joinTable2 = datatableListTwo;
    } else {
      // Set the joinTable1 and joinTable2 properties with the full paths
      buildJoin.joinTable1 = `${selectedCatalogUntilJoinNode[0]}.${selectedDatabaseUntilJoinNode[0]}.${datatableListOne}`;
      buildJoin.joinTable2 = `${selectedCatalogUntilJoinNode[1]}.${selectedLastDatabaseLastName}.${datatableListTwo}`;
    }

    for (let i = 0; i < combinedJoinOneColumns.length; i++) {
      const columnComparisonOperatorValue = combinedJoinColumnComparisonOperator[i];
      console.log("columnComparisonOperatorValue::11", combinedJoinOneColumns);
      let combinedJoinOneColumnsValue = combinedJoinOneColumns[i].split('AS')[0];
      let combinedJoinTwoColumnsValue = combinedJoinTwoColumns[i].split('AS')[0];
      console.log("columnComparisonOperatorValue::22", combinedJoinOneColumnsValue, combinedJoinTwoColumnsValue );
      if (connectionType = 'kafka') {
      const col_part = combinedJoinOneColumnsValue.split('_message_')
      combinedJoinOneColumnsValue = 'json_extract_scalar(' + col_part[0] + '_message,' + "'$." + col_part[1] + "') AS " + '_message_' + col_part[1];
      combinedJoinOneColumnsValue = combinedJoinOneColumnsValue.split('AS')[0]
      const col_part2 = combinedJoinTwoColumnsValue.split('_message_')
      combinedJoinTwoColumnsValue = 'json_extract_scalar(' + col_part2[0] + '_message,' + "'$." + col_part2[1] + "') AS " + '_message_' + col_part2[1];
      combinedJoinTwoColumnsValue = combinedJoinTwoColumnsValue.split('AS')[0]
    }
      const columnData = {
        joinOperator: i > 0 ? logicalOperators[i] : '', // Use the join operator based on the index
        columnComparisionOperator: columnComparisonOperatorValue,
        table1Column: combinedJoinOneColumnsValue,
        table2Column: combinedJoinTwoColumnsValue
      };
      console.log("columnComparisonOperatorValue::33", combinedJoinOneColumnsValue, combinedJoinTwoColumnsValue, additionalColumnOne, additionalColumnTwo);
      console.log(JSON.stringify(columnData) + "columnData:11");
      buildJoin.columnDetails.push(columnData);
      // Stringify the columnDetails array
    }

    buildJoin.columnDetails = JSON.stringify(buildJoin.columnDetails); // Convert to string 
    const buildJoinValue = [{ buildJoin: JSON.stringify(buildJoin) }];
    console.log(JSON.stringify(buildJoin.columnDetails) + "buildJoin::11");
    const showAdditionalColumnslength = showAdditionalColumns.length;
    console.log("datatableListTwo::1", datatableColumnOne, datatableColumnTwo,datatableListOne,datatableListTwo);
    onValueSubmit(selectedNodeId, name, joinType, compareType, datatableListOne,
      datatableListTwo, 
      datatableColumnOne, datatableColumnTwo,
      buildJoin, additionalLogicalOperators,
      additionalColumnOne, additionalColumnTwo,
      showAdditionalColumnslength, additionalCompareType);
    }

  const handleJoinTypeChange = (event) => {
    setJoinType(event.target.value);
  };

  const renderDatatable1ColumnOptions = () => {
    // Assuming dropdownTableOptions is an array containing the table objects
    const selectedTable = selectedTablesUntilJoinNode.find(option => option === datatableListOne);
    const index = selectedTablesUntilJoinNode.indexOf(datatableListOne);
    if (selectedTable) {
      const columnOptions = selectedColumnsUntilJoinNode[index].map(column => (
        <option key={column} value={column}>
          {column.split(".").at(-1)}
        </option>
      ));
      // Add aliasColumn as an additional option
      if (aliasColumn && aliasColumn[index] !== '' && aliasColumn.length > 0) {
        aliasColumn[index]
          .flat(Infinity) // Flatten the array to handle nested arrays of any depth
          .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
          .forEach((value, index) => {
            columnOptions.push(
              <option key={index} value={value}>
                {value}
              </option>
            );
          });
      }
      return columnOptions;
    }
    else if (selectedTablesUntilJoinNode.length > 0 && selectedColumnsUntilJoinNode[0]) {
      // Render the columns from the first table in the selectedTablesUntilJoinNode array
      const firstTableColumns = selectedColumnsUntilJoinNode[0];
      const columnOptions = firstTableColumns.map(column => (
        <option key={column} value={column}>
          {column}
        </option>
      ));
      // Add aliasColumn as an additional option
      if (aliasColumn && aliasColumn[0] !== '' && aliasColumn.length > 0) {
        aliasColumn[0]
          .flat(Infinity) // Flatten the array to handle nested arrays of any depth
          .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
          .forEach((value, index) => {
            columnOptions.push(
              <option key={index} value={value}>
                {value}
              </option>
            );
          });
      }
      return columnOptions;
    }

    return null;  // Or you can return a default option or an empty array if needed
  };

  const renderDatatable2ColumnOptions = () => {
    // alert(JSON.stringify(datatableListTwo) + "datatableListTwo");

    const selectedTable = selectedTablesUntilJoinNode.find(option => option === datatableListTwo);

    if (selectedTable) {

      const columnOptions = selectedLastTableLastColumnName.map((column, index) => (
        <option key={index} value={column}>
          {column.split(".").at(-1)}
        </option>
      ))
      // Add aliasColumn as an additional option
      if (aliasColumn[aliasColumn.length - 1] && aliasColumn[aliasColumn.length - 1] !== '' && aliasColumn[aliasColumn.length - 1].length > 0) {
        // Get the last array in aliasColumn
        const lastArray = aliasColumn[aliasColumn.length - 1];

        if (lastArray && lastArray.length > 0) {
          lastArray
            .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
            .forEach((value, index) => {
              columnOptions.push(
                <option key={index} value={value}>
                  {value}
                </option>
              );
            });
        }
      }

      return columnOptions;
    }

    else if (selectedTablesUntilJoinNode.length > 0 && selectedColumnsUntilJoinNode[selectedColumnsUntilJoinNode.length - 1]) {
      // Render the columns from the first table in the selectedTablesUntilJoinNode array
      const secondTableColumns = selectedColumnsUntilJoinNode[selectedColumnsUntilJoinNode.length - 1];
      const columnOptions = secondTableColumns.map(column => (
        <option key={column} value={column}>
          {column}
        </option>
      ));
      // Add aliasColumn as an additional option
      if (aliasColumn && aliasColumn[aliasColumn.length - 1] !== '' && aliasColumn.length > 0) {
        // Get the last array in aliasColumn
        const lastArray = aliasColumn[aliasColumn.length - 1];

        if (lastArray && lastArray.length > 0) {
          lastArray
            .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
            .forEach((value, index) => {
              columnOptions.push(
                <option key={index} value={value}>
                  {value}
                </option>
              );
            });
        }
      }

      return columnOptions;
    }

    return null; // Or you can return a default option or an empty array if needed
  };

  const handleAddColumns = () => {

    const selectedLastColumnsJoinNode = selectedColumnsUntilJoinNode[selectedColumnsUntilJoinNode.length - 1];
    const newAdditionalLogicalOperators = [...additionalLogicalOperators, dropdownLogicalOperator[0].value];
    const newAdditionalCompareType = [...additionalCompareType, dropdownCompareToOptions[0].symbol];

    const newAdditionalColumnOne = [...additionalColumnOne, selectedColumnsUntilJoinNode[0][0]];
    const newAdditionalColumnTwo = [...additionalColumnTwo, selectedLastColumnsJoinNode[0]];

    setAdditionalLogicalOperators(newAdditionalLogicalOperators);
    setAdditionalCompareType(newAdditionalCompareType);

    setAdditionalColumnOne(newAdditionalColumnOne);
    setAdditionalColumnTwo(newAdditionalColumnTwo);
    console.log(newAdditionalColumnOne + "*****" + newAdditionalColumnTwo);

    console.log(additionalColumnTwo + "*****" + additionalColumnTwo);
    setShowAdditionalColumns([...showAdditionalColumns, {}]);
    setAdditionalColumnOne(additionalColumnOne => [...additionalColumnOne]);
    setAdditionalColumnTwo(additionalColumnTwo => [...additionalColumnTwo]);
    setAdditionalLogicalOperators(additionalLogicalOperators => [...additionalLogicalOperators]);
    setAdditionalCompareType(additionalCompareType => [...additionalCompareType]);

    console.log(newAdditionalColumnOne + "newAdditionalColumnOne44444444");
    console.log(newAdditionalColumnTwo + "newAdditionalColumnTwo33333333");
    console.log(newAdditionalLogicalOperators + "newAdditionalLogicalOperators22222");
    console.log(newAdditionalCompareType + "newAdditionalCompareType1111111");
  };

  const handleRemoveColumns = (index) => {

    setShowAdditionalColumns(prevState => {
      const updatedState = [...prevState];
      updatedState.splice(index, 1);
      return updatedState;
    });
    setAdditionalColumnOne(prevState => {
      const updatedState = [...prevState];
      updatedState.splice(index, 1);
      return updatedState;
    });
    setAdditionalColumnTwo(prevState => {
      const updatedState = [...prevState];
      updatedState.splice(index, 1);
      return updatedState;
    });

    if (showAdditionalColumns.length === 0) {
      // If the last column is removed, clear the showAdditionalColumns length
      setShowAdditionalColumns([]);
    }
  };


  const handleAdditionalColumnOneChange = (index, event) => {

    const { value } = event.target;

    // Update the selectedThenByColumns state with the selected value
    const updatedColumns = [...additionalColumnOne];
    updatedColumns[index] = value;
    setAdditionalColumnOne(updatedColumns);

  };

  const handleAdditionalColumnTwoChange = (index, event) => {

    const { value } = event.target;

    setAdditionalColumnTwo((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });

  };


  const handleLogicalOperatorChange = (event, index) => {
    const { value } = event.target;
    setAdditionalLogicalOperators((prevOperators) => {
      const updatedOperators = [...prevOperators];
      updatedOperators[index] = value;
      return updatedOperators;
    });
  };

  const handleFilterGroupChange = (event, index) => {
    const { value } = event.target;

    setAdditionalCompareType((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };

  const renderAdditionalColumns = () => {

    if (showAdditionalColumns.length > 0) {

      return additionalColumnOne.map((showColumns, index) => (

        <div key={index} className="additional-input">
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Join Separator</label>
            <select
              id={`dropdown-${index}`}
              className="form-control"
              value={additionalLogicalOperators[index]}
              onChange={(event) => handleLogicalOperatorChange(event, index)}
            >
              {dropdownLogicalOperator.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}

            </select>
          </div>
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Compare Type</label>
            <select id={`dropdown-${index}`} className="form-control"
              value={additionalCompareType[index]}
              onChange={(event) => handleFilterGroupChange(event, index)}>
              {dropdownCompareToOptions.map((option) => (
                <option key={option.value} value={option.symbol}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor={`additionalColumnOne-${index}`}>Additional Column 1</label>
            <select
              id={`additionalColumnOne-${index}`}
              className="form-control"
              value={additionalColumnOne[index]}
              onChange={(e) => handleAdditionalColumnOneChange(index, e)}
            >
              {/* Render additional column options here */}
              {renderDatatable1ColumnOptions()}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor={`additionalColumnTwo-${index}`}>Additional Column 2</label>
            <select
              id={`additionalColumnTwo-${index}`}
              className="form-control"
              value={additionalColumnTwo[index]}
              onChange={(e) => handleAdditionalColumnTwoChange(index, e)}
            >

              {renderDatatable2ColumnOptions()}
            </select>
          </div>

          <div className="add-remove-buttons">
            <button
              type="button"
              className="btn btn-danger remove"
              onClick={(event) => handleRemoveColumns(index)}
            >
              Remove
            </button>
          </div>
        </div>
      ));

    }
    return null;
  };



  const handleFilterChange = (event) => {
    setCompareType(event.target.value);
  };


  return (
    <div className="overlay">

      <div className="popup-datatable">
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name </label>
              <input type="text" value={name} onChange={handleNameChange} className="form-control" id="textbox" />
            </div>


            <div className="form-group">
              <label htmlFor="dropdown">Join Type</label>
              <select id="dropdown" className="form-control"
                value={joinType} onChange={handleJoinTypeChange}>
                {dropdownJoinTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="textbox">Table 1 Name : </label>
              {/* <input type="text"  value={dataTableOneNodeData.name} className="form-control" id="textbox" />
          */}
              <select className="dropdown" value={datatableListOne}
                onChange={handleSelectedDatatableOneChange}>

                {selectedTablesUntilJoinNode.length > 1
                  ? selectedTablesUntilJoinNode.slice(0, selectedTablesUntilJoinNode.length - 1).map((table) => (
                    <option key={table} value={table}>
                      {table}
                    </option>
                  ))
                  : selectedTablesUntilJoinNode.map((table) => (
                    <option key={table} value={table}>
                      {table}
                    </option>
                  ))
                }

              </select>

            </div>

            <div className="form-group">
              <label htmlFor="dropdown">Tabel 1 Column</label>
              <select id="dropdown" className="form-control"
                value={datatableColumnOne} onChange={handleDatatableOneChange}>
                {renderDatatable1ColumnOptions()}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="dropdown">Compare Type</label>

              <select id="filterDropdown" className="form-control"
                value={compareType} onChange={handleFilterChange}>
                {dropdownCompareToOptions.map((option) => (
                  <option key={option.value} value={option.symbol}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="textbox">Table 2 Name</label>

              <select disabled className="dropdown" value={datatableListTwo}
                onChange={handleSelectedDatatableTwoChange}>

                {selectedTablesUntilJoinNode.map((option, index) => (
                  <option key={option} value={option} selected={index === selectedTablesUntilJoinNode.length - 1}>
                    {option}
                  </option>
                ))}


              </select>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">Tabel 2 Column</label>
              <select id="dropdown" className="form-control"
                value={datatableColumnTwo} onChange={handleDatatableTwoChange}>
                {renderDatatable2ColumnOptions()}


              </select>
            </div>

            {/* Additiona division */}

            {renderAdditionalColumns()}



            <div className="form-group">
              <button type='button' className='btn btn-primary' onClick={handleAddColumns}>
                Add Another

              </button>

            </div>
            <div className="form-group toolHelpLink">
              <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
                How does this tool work?
              </a>
            </div>
          </div>
          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Delete Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={(event) => handleSubmit(event)}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinPopupComponent;
